import '../styles/error.scss';

const ErrorView = () => (
    <div className="true-comply_error">
        <div>
            <span className="appkiticon icon-alert-outline a-font-40 a-text-red" />
        </div>
        <div className="a-mt-10 a-h2">An Error Ocurred!</div>
    </div>
);

export default ErrorView;
